import { ApolloError } from '@apollo/client'
import { useMemo } from 'react'

import {
  GetCustomerRewardsOrdersDocument,
  GetCustomerRewardsOrdersQuery,
} from '../../../graphql/camel'
import useCamelQuery from '../../../hooks/useCamelQuery'
import { RewardsSourceConfig } from '../../rewards/sources'

export interface UseGetCustomerRewardsOrders {
  data?: GetCustomerRewardsOrdersQuery
  error?: ApolloError | Error
  fetchMoreOrders?: () => Promise<unknown>
  loading: boolean
  refetch: () => Promise<unknown>
}

export function useGetCustomerRewardsOrders({
  filter,
}: Pick<RewardsSourceConfig, 'filter'>): UseGetCustomerRewardsOrders {
  const { data, fetchMore, loading, error, refetch } = useCamelQuery(
    GetCustomerRewardsOrdersDocument,
    {
      variables: {
        rewardsSource: filter,
      },
      notifyOnNetworkStatusChange: true,
    },
  )

  const fetchMoreOrders = useMemo(() => {
    const { pageInfo } = data?.getCustomerRewardsOrders?.meta || {}
    if (!pageInfo || pageInfo.currentPage >= pageInfo.totalPages) {
      return undefined
    }
    return () =>
      fetchMore({
        variables: {
          page: pageInfo.currentPage + 1,
        },
      })
  }, [data?.getCustomerRewardsOrders?.meta, fetchMore])

  return { data, error, fetchMoreOrders, loading, refetch }
}
